
export const UserAttribute = Object.freeze({
   LMS_ID: "LMS_ID",
   IIN: "IIN"
});

export const UserRoles = Object.freeze({
    ROLE_DO_HEAD: "ROLE_DO_HEAD"
});